import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-modal-intro',
  standalone: true,
  imports: [MatButtonModule, TranslateModule],
  templateUrl: './modal-intro.component.html',
  styleUrls: ['./modal-intro.component.scss']
})
export class ModalIntroComponent {
  constructor(public dialogRef: MatDialogRef<ModalIntroComponent>) {}

  closeModal() {
    this.dialogRef.close();
  }
}
